// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cn-section-header{--ab-canyon-section-header-color-text:var(--ab-canyon-color-primary);color:var(--ab-canyon-color-primary);color:var(--ab-canyon-section-header-color-text);font-size:1.5rem;font-weight:700;line-height:2rem;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
